// Chart1.js
import React, { useEffect, useState } from 'react'
import { Doughnut } from 'react-chartjs-2'

const DoughnutChart = (props) => {
    const isTrends = props.isTrends
    const [trendData, setTrendData] = useState({})

    let exactdata = {
        labels: ['Time Elapsed:', 'Time Accomplished:'],
        datasets: [
            {
                label: '# of Users',
                data: [],
                backgroundColor: ['#72C77C', '#348D3E'],
                borderColor: ['#72C77C', '#348D3E'],
                borderWidth: 1,
            },
        ],
    }

    useEffect(() => {
        if (props.dashboardData && props.dashboardData.length) {
            console.log(props.dashboardData, 'pyuuu')
            let allData = [
                props.dashboardData[0]?.bookingCount,
                props.dashboardData[0]?.servingCount,
                props.dashboardData[0]?.removedCount,
                props.dashboardData[0]?.noshowCount,
            ]
            // trendData.lebels.push(['New orders: 10', 'Served: 20', 'Cancelled: 2', 'No-show: 1'])
            setTrendData({
                labels: [
                    `New orders: ${props.dashboardData[0]?.bookingCount}`,
                    `Served: ${props.dashboardData[0]?.servingCount}`,
                    `Cancelled: ${props.dashboardData[0]?.removedCount}`,
                    `No-show: ${props.dashboardData[0]?.noshowCount}`,
                ],
                datasets: [
                    {
                        label: 'New orders',
                        data: allData,
                        backgroundColor: [
                            '#45BF53',
                            '#72C77C',
                            '#348D3E',
                            '#B8F2BF',
                        ],
                        borderColor: [
                            '#45BF53',
                            '#72C77C',
                            '#348D3E',
                            '#B8F2BF',
                        ],
                        borderWidth: 1,
                    },
                    {
                        label: 'Served',
                        data: allData,
                        backgroundColor: [
                            '#45BF53',
                            '#72C77C',
                            '#348D3E',
                            '#B8F2BF',
                        ],
                        borderColor: [
                            '#45BF53',
                            '#72C77C',
                            '#348D3E',
                            '#B8F2BF',
                        ],
                        borderWidth: 1,
                    },
                    {
                        label: 'Cancelled',
                        data: allData,
                        backgroundColor: [
                            '#45BF53',
                            '#72C77C',
                            '#348D3E',
                            '#B8F2BF',
                        ],
                        borderColor: [
                            '#45BF53',
                            '#72C77C',
                            '#348D3E',
                            '#B8F2BF',
                        ],
                        borderWidth: 1,
                    },
                    {
                        label: 'No-show',
                        data: allData,
                        backgroundColor: [
                            '#45BF53',
                            '#72C77C',
                            '#348D3E',
                            '#B8F2BF',
                        ],
                        borderColor: [
                            '#45BF53',
                            '#72C77C',
                            '#348D3E',
                            '#B8F2BF',
                        ],
                        borderWidth: 1,
                    },
                ],
            })

            // exactdata.datasets.map(() => {
            //     data.data.push([12,19])
            // })
        }
    }, [props.dashboardData])

    const options = {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
            tooltip: {
                titleFont: {
                    size: 15,
                },
                bodyFont: {
                    size: 15,
                },
            },
            legend: {
                display: true,
                position: 'right',
                labels: {
                    pointStyle: 'circle',
                    usePointStyle: true,
                    padding: 15,
                    font: {
                        size: 12,
                    },
                },
                align: 'center',
            },
        },
        cutout: '80%',
        radius: 90,
    }

    const trendOptions = {
        responsive: true,
        maintainAspectRatio: false,
        chartArea: {
            // Adjust padding for text placement
            top: 20,
            bottom: 20,
            left: 50,
            right: 50,
        },
        plugins: {
            tooltip: {
                titleFont: {
                    size: 15,
                },
                bodyFont: {
                    size: 15,
                },
            },
            legend: {
                display: true,
                position: 'right',
                labels: {
                    boxWidth: 150,
                    borderRadius: false,
                    pointStyle: 'circle',
                    usePointStyle: true,
                    padding: 25,
                    backgroundColor: '#000',
                    font: {
                        size: 14,
                    },
                },
                align: 'center',
            },
        },
        scales: {
            yAxes: [
                {
                    ticks: {
                        display: false,
                    },
                },
            ],
        },
        cutout: '80%',
    }

    return props?.dashboardData?.length && Object.keys(trendData).length ? (
        <Doughnut
            data={isTrends ? trendData : exactdata}
            options={isTrends ? trendOptions : options}
        />
    ) : null
}

export default DoughnutChart
